import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const CloseWebviewBtn = styled(Button).attrs({
  appearance: 'transparent',
})``;

export const NewAdBtn = styled(Button).attrs({
  appearance: 'transparent',
  hasPadding: false,
})``;
